<template>
    <div class="container footer-menu">
        <div class="parent">
            <div class="example">
                <nav v-if="showMenu" aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item" >
                            <router-link to="/registration-forceclub/FAQ" target="_blank" rel="noopener noreferrer">{{ $t('menu.faq') }}</router-link>
                        </li>
                        <li class="breadcrumb-item" >
                            <router-link to="/registration-forceclub/terms" target="_blank" rel="noopener noreferrer">{{ $t('menu.terms') }}</router-link>
                        </li>
                        <li class="breadcrumb-item" >
                            <router-link to="/registration-forceclub/policy" target="_blank" rel="noopener noreferrer">{{ $t('menu.policy') }}</router-link>
                        </li>
                        <li class="breadcrumb-item" >
                            <router-link to="/registration-forceclub/company" target="_blank" rel="noopener noreferrer">{{ $t('menu.operating') }}</router-link>
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
    import AuthUtil from '../../utils/AuthUtil';

    export default {
        name: 'footer-menu',
        data(){
          return {
              isLogged: false,
          }
        },
        props: {
            showMenu: {
                type: Boolean,
                default: true
            },
            isAuth: {
                type: Boolean,
                default: false
            },
            displayLogin: {
                type: Boolean,
                default: true
            }
        },
        async mounted() {
            this.isLogged = AuthUtil.isAuth();
        },
    }
</script>

<style scoped lang="css">
    .parent {
        text-align: center;
    }
    .example {
        display: inline-block;
    }
    /*PC PAD用css*/
    @media screen and (min-width: 991px) {
        .footer-menu {
            margin-top: auto;
        }
    }
    @media screen and (max-width: 991px) {
        .footer-menu {
            margin-top: auto;
            width: none;
            margin: auto;
        }
        .parent {
            text-align: initial;
        }
    }
</style>